import React, { useEffect, useState, useRef } from "react"
import ReactDOM from "react-dom"
import Head from "next/head"
import { useDispatch, useSelector } from "react-redux"
import { mapMainMenuProps } from "@/components/DesignSystem/mappers/navigationV2Mapper"
import Script from "next/script"
import {
  formatPhoneNumber,
  getMyLocation,
  getPageLevelScriptsAndStyles,
  getRandom,
  isCanadaSite,
  getCityList,
  addMavenoidChat,
  removeMavenoidChat,
  handleSkipToMain,
} from "@/utils/helper"
import {
  findItemByName,
  hasHeaderItems,
} from "@/components/DesignSystem/utils/navigationHelper"
import {
  selectGenericState,
  showPromoModal,
} from "@/store/features/genericSlice"
import { MainMenu } from "@kohler-dsm-library/kohler-modules"
import UtilityWidgets from "../UtilityWidgets/v1/UtilityWidgets"
import {
  getFavorites,
  getMyAccountListsWithLineItems,
  selectFavoritesState,
} from "@/store/features/favoritesSlice"
import useAuthUtilityNavi18n from "@/i18n/useAuthUtilityNavi18n"
import {
  logout,
  selectAuthState,
  setAuthModalVisibility,
} from "@/store/features/authSlice"
import { GLOBAL_CONFIGURATION_ENDPOINT } from "@/constants/index"
import { aemAxiosInstance } from "@/constants/api"
import { useRouter } from "next/router"
import { getCartCount } from "@/utils/cart"
import { getShortenedUrl } from "@/utils/location"
import { MY_LISTS_PAGE_PATH } from "@/constants/routes"
import { getConfig } from "@/constants/config"
import _get from "lodash/get"
import { headerFindStoreUseLocationAnalytics } from "@/components/FindStoreUtilNav/analytics"
import { getTranslations } from "@/components/FindStoreUtilNav/v1/localization"
import get from "lodash/get"
import { getUtilityStoreDetails } from "@/utils/location"
import { useTranslation } from "react-i18next"
import {
  locationState,
  setStoreAddress,
  setMyStore,
  setUtilityStoreDetails,
} from "@/store/features/locationSlice"
import { getFindAStoresResult } from "@/components/FindStore/v1/api"
import _isEmpty from "lodash/isEmpty"
import ZipCodeInfoModal from "@/components/core/Modal/ZipCodeInfoModal"
import useFindStorei18n from "@/i18n/useFindStorei18n"
import {
  dataLayerForSignOut,
  dataLayerForUtilityClicks,
  newdataLayerForCreateAccount,
  newdatalayerforSignIn,
} from "@/components/Shared/HeaderNavTabs/analytics/index"
import GlobalVisualSearch from "@/components/GlobalVisualSearch/GlobalVisualSearch"
import { isMobile } from "react-device-detect"
import useWindowResize from "@/hooks/useWindowResize"
import { setDynamicSearchFragment } from "@/store/features/searchSlice"
import useViewport from "@/hooks/useViewport"
import { useIsVSFeatFirstTime } from "@/hooks/useIsVSFeatFirstTime"
import GlobalVSContent from "@/components/GlobalVisualSearch/GlobalVSContent"
import SearchNotification from "@/components/GlobalVisualSearch/SearchNotification"

const configInitialState = {
  browseAllStoreUrl: "",
  brand: "",
  findStores: "",
}

const GlobalPageHeader = props => {
  const {
    themeType = "",
    header = {},
    title = "",
    description = "",
    globalScripting = "",
    isPdp = false,
    imageUrl = "",
    email = "",
    phone = "",
    fullUrl = "",
    siteName = "",
  } = props
  const {
    pageIsInteractive,
    featureFlags = {},
    globalConfig: {
      internationalization: { language = "en" } = {},
      general: {
        cartLandingPagePath = "",
        signInFragment = "",
        signUpFragment = "",
        navigationHoverTiming = "",
        siteName: BrandName = "",
      } = {},
    } = {},
  } = useSelector(selectGenericState)
  const { utilityStoreDetails, utilityData, myStoreId } =
    useSelector(locationState)

  const initialState = {
    userCity: "",
    utilityLocation: "",
    utilityData: {},
    utilityStoreDetails: {},
    findStores: "",
    reverseGeo: "",
    myStoreId:
      typeof Window !== "undefined" ? localStorage.getItem("myStoreId") : 0,
    siteName: "",
    findStoreUrl: "",
    utilityStoreDetailsUrl: "",
  }

  const { data: authorData = {} } = props
  const staticTexts = useFindStorei18n({
    authorData,
  })

  const bodyRef = useRef(null)
  const htmlRef = useRef(null)

  const [metas, setMetas] = useState([])
  const [styles, setStyles] = useState([])
  const [scripts, setScripts] = useState([])
  const [links, setLinks] = useState([])
  const [logIndata, setLogIndata] = useState([])
  const [logOutdata, setLogOutdata] = useState([])
  const [favoritesPagePath, setFavoritesPagePath] = useState("/")
  const [favoritesPage, setFavoritesPage] = useState([])
  const {
    MYSQLCONNSTR_ENABLE_SHOPPING_LISTS_V2: isSaveProductToList = false,
    MYSQLCONNSTR_ENABLE_GLOBAL_VISUAL_SEARCH_V1:
      isGlobalVisualSearchEnabled = false,
  } = featureFlags
  const { favorites = {}, saveToListLineItems = {} } =
    useSelector(selectFavoritesState)
  const { lineItems = [] } = favorites || {}
  const { isLargeScreen, isExtraLargeScreen } = useViewport()
  const i18n = useAuthUtilityNavi18n()
  const router = useRouter()
  const cartCount = getCartCount()
  const { user: { firstName = null } = {}, isAuth = false } =
    useSelector(selectAuthState)
  const { globalConfig } = useSelector(selectGenericState)

  const dispatch = useDispatch()

  const onclicksignIN = (datalayershow = true) => {
    dispatch(setAuthModalVisibility({ show: true }))
    if (datalayershow) {
      newdatalayerforSignIn()
    }
  }
  const onClickCreateAccount = () => {
    dispatch(setAuthModalVisibility({ show: true, active: 1 }))
    newdataLayerForCreateAccount()
  }
  const [loginFavouriteCallback, setLoginFavouriteCallback] = useState(null)
  const [myListsPagePath, setMyListsPagePath] = useState("/")
  const [configState, setConfigState] = useState(configInitialState)
  const [target, setTarget] = useState(null)

  // for search panel
  const [showSearchBar, setShowSearchBar] = useState(false)
  const [openVisualSearch, setOpenVisualSearch] = useState(false)
  const { t } = useTranslation("common")
  const staticText = getTranslations(t)
  const [state, setState] = useState(initialState)
  const [zipCodeValue, setZipcodeValue] = useState("")
  const [infoModalErrror, setInfoModalErrror] = useState({})
  const [infoModal, setInfoModal] = useState()
  const [browseAllStoreUrl, setbrowseAllStoreUrl] = useState("")
  const [myStoreUrl, setMyStoreUrl] = useState("/")
  const [optionList, setOptionList] = useState([])
  const [canadaCheck, setCanadaCheck] = useState(false)
  const [isFirstTime, setIsFirstTime] = useIsVSFeatFirstTime()
  const [searchIconContainer, setSearchIconContainer] = useState(null)

  const setExperianceFragmentValue = () => {
    const fragmentPath =
      header?.[":items"]?.["root"]?.[":items"]?.["container_copy"]?.[
        ":items"
      ]?.["dynamicsearch"]?.["fragmentPath"] ?? null
    if (fragmentPath) {
      dispatch(
        setDynamicSearchFragment({ found: true, fragmentPath: fragmentPath })
      )
    }
  }

  useEffect(() => {
    if (state.utilityStoreDetailsUrl !== "") setUtilityStoreDetailsUrl()
  }, [state.utilityStoreDetailsUrl])

  useEffect(() => {
    setInitalState()
    setExperianceFragmentValue()
  }, [])

  useEffect(() => {
    const iscanadaCheck = isCanadaSite(BrandName)
    setCanadaCheck(iscanadaCheck)
  }, [BrandName])

  const handleGlobalClick = e => {
    const target = e.target.closest(
      '[data-datalayer-id="kds-element-navigation"]'
    )
    if (target) {
      const rawEventInfo = JSON.parse(
        target?.attributes?.["data-datalayer-data"]?.nodeValue || "{}"
      )
      const page = window.pageObj || {}

      // Common attributes to add to all events
      const commonEventInfo = {
        eventAction: rawEventInfo.eventAction || "main dropdown menu",
        eventType: rawEventInfo.eventType || "global header",
        eventName: rawEventInfo.eventName || "main dropdown menu",
        internalLinkPosition:
          rawEventInfo?.internalLinkPosition || "global header",
        internalLinkZoneName:
          rawEventInfo?.internalLinkZoneName || "global header",
        internalLinkType:
          rawEventInfo?.internalLinkType || "global header:navigation",
      }

      const getProductInfo = () => {
        if ((rawEventInfo.internalLinkPosition || "").includes("teaser")) {
          const productInfo = {
            productCategory: "n/a",
            productCollectionsName: "n/a",
            productRoom: "n/a",
          }
          return productInfo
        }
      }
      const isproductInfo = getProductInfo()

      // Merge common attributes with specific event info
      let eventInfo = {}
      eventInfo = {
        ...rawEventInfo,
        ...commonEventInfo,
      }

      if (isproductInfo) {
        window.adobeDataLayer.push({
          event: "cmp:click",
          page,
          eventInfo,
          productInfo: isproductInfo,
        })
      } else {
        window.adobeDataLayer.push({
          event: "cmp:click",
          page,
          eventInfo,
        })
      }
    }
  }
  useEffect(() => {
    document.addEventListener("click", handleGlobalClick)
    return () => document.removeEventListener("click", handleGlobalClick)
  }, [])

  const setInitalState = async () => {
    const config = await getConfig()
    getFindStoreUrl(config).then(url => {
      setState({
        ...state,
        findStores: get(config, "apiEndpoints.findStores", ""),
        reverseGeo: get(config, "apiEndpoints.reverseGeo", ""),
        siteName: get(config, "general.siteName", ""),
        utilityStoreDetailsUrl: get(config, "general.storeDetailsServletPath"),
        findStoreUrl: url,
      })
    })
  }
  const getFindStoreUrl = async config => {
    const findStoreUrl = await getShortenedUrl(
      get(config, "general.findStorePagePath", "")
    )
    return findStoreUrl
  }

  const setUtilityStoreDetailsUrl = async () => {
    const utilityStoreDetails = await getUtilityStoreDetails(state)
    dispatch(setUtilityStoreDetails(utilityStoreDetails))
    setState({
      ...state,
      utilityStoreDetails,
    })
  }

  const redirect = zipCodeValue => {
    const path = `${state.findStoreUrl}?q=${zipCodeValue}&queryAspath=${state.findStoreUrl}`
    const asPath = `${state.findStoreUrl}?q=${zipCodeValue}`
    router.push(path, asPath)
  }
  const handleZipCodeUpdate = value => {
    setZipcodeValue(value)
  }
  const headerItemsPresent = hasHeaderItems(header)
  const getGeoLocation = () => {
    getMyLocation()
      .then(getLocation => {
        setZipcodeValue(
          getLocation.zipcode ? Number(getLocation.zipcode) : undefined
        )
        headerFindStoreUseLocationAnalytics({ eventStatus: "success" })
      })
      .catch(({ cause }) => {
        setInfoModalErrror(cause ?? {})
        setInfoModal(true)
        headerFindStoreUseLocationAnalytics({
          errorMessage: cause?.message ?? "",
          staticTexts,
          eventStatus: "failure",
        })
      })
  }
  useEffect(() => {
    getConfig()
      .then(async config => {
        const {
          apiEndpoints: { findStores = "" } = {},
          general: { allStoresPagePath = "/", siteName = "" } = {},
        } = config || {}

        const url = await getShortenedUrl(allStoresPagePath ?? "/")

        setConfigState({
          browseAllStoreUrl: url,
          findStores,
          brand: siteName,
        })
        localStorage.getItem("currentZipCode") &&
          setZipcodeValue(localStorage.getItem("currentZipCode"))
        setbrowseAllStoreUrl(url)
      })
      .catch(err => console.log(err))
  }, [])

  useEffect(() => {
    if (myStoreId === 0) {
      nearestStoreAddress()
    } else {
      dispatch(setStoreAddress(utilityData))
    }
  }, [zipCodeValue, myStoreId])

  useEffect(() => {
    if (zipCodeValue.length > 2) {
      fetchListOfCities()
    }
  }, [zipCodeValue])

  const fetchListOfCities = async () => {
    const { findStores, brand } = configState
    const responseData = await getCityList(findStores, brand, zipCodeValue)
    const { data: { d: { results = [] } = {} } = {} } = responseData
    const cities = results.map(city => city.Locality)
    setOptionList([...new Set(cities)])
  }

  const nearestStoreAddress = async () => {
    getConfig()
      .then(async config => {
        const findStores = get(config, "apiEndpoints.findStores", "")
        const brand = get(config, "general.siteName", "")
        if (!findStores || zipCodeValue?.length < 3) return
        const nearestStore = await getFindAStoresResult(
          findStores,
          zipCodeValue,
          brand,
          100,
          1,
          "kohler store",
          1
        )
        if (nearestStore !== undefined) {
          const nearestStoreData = nearestStore?.data?.info[0] ?? {}
          const utilityData = {
            ...nearestStoreData,
            EntityID: nearestStoreData?.BPnumber ?? null,
          }
          dispatch(setStoreAddress(utilityData))
        } else {
          const utilityData = {}
          dispatch(setStoreAddress(utilityData))
        }
      })
      .catch(err => console.log(err))
  }
  useEffect(() => {
    if (!_isEmpty(utilityStoreDetails) && utilityData?.BPnumber) {
      getShortenedUrl(utilityStoreDetails[utilityData.BPnumber]).then(
        myStoreUrl => {
          setMyStoreUrl(myStoreUrl)
        }
      )
    }
  }, [utilityStoreDetails, utilityData])

  const handleUtilityStoreCheck = entity => {
    localStorage.setItem("myStoreId", entity)
    dispatch(setMyStore(entity))
    setState({
      ...state,
      myStoreId: entity,
    })
  }

  const pageUrl =
    fullUrl || (typeof window !== "undefined" ? window?.location?.href : "")

  useEffect(() => {
    const { pageLevelDetails = [] } =
      getPageLevelScriptsAndStyles(globalScripting)
    setMetas(pageLevelDetails["metaList"])
    setStyles(pageLevelDetails["stylesList"])
    setScripts(pageLevelDetails["pageScripts"])
    setLinks(pageLevelDetails["linkList"])
  }, [globalScripting])

  // for search panel
  useEffect(() => {
    if (typeof window !== "undefined") {
      bodyRef.current = document.body
      htmlRef.current = document.getElementsByTagName("html")[0]
    }
  }, [])

  const handleSearchClick = () => {
    if (showSearchBar) {
      addMavenoidChat()
    } else {
      if (isMobile) {
        removeMavenoidChat()
      } else {
        addMavenoidChat()
      }
    }

    const classNames = ["searchbar-open", "scroll-lock"]
    if (showSearchBar) {
      classNames.forEach(className => {
        bodyRef?.current?.classList?.remove(className)
        htmlRef?.current?.classList?.remove(className)
      })
    } else {
      classNames.forEach(className => {
        bodyRef?.current?.classList?.add(className)
        htmlRef?.current?.classList?.add(className)
      })
    }
    setShowSearchBar(!showSearchBar)
    const page = window.pageObj || {}
    const previousPageNameForSearch = page?.pageInfo?.pageName
    sessionStorage.setItem(
      "previousPageNameForSearch",
      previousPageNameForSearch
    )
  }

  useEffect(() => {
    if (isSaveProductToList) {
      setFavoritesPagePath(`/${language}${MY_LISTS_PAGE_PATH}`)
    } else {
      getConfig().then(async config => {
        const myFavPath = _get(config, "general.myFavoritesPagePath", "")
        setFavoritesPagePath(await getShortenedUrl(myFavPath ?? "/"))
      })
    }
  }, [isSaveProductToList])

  useEffect(() => {
    if (isAuth) {
      dispatch(getFavorites())
        .unwrap()
        .then(rsp => {
          if (rsp && rsp !== null) {
            setFavoritesPage(rsp.lineItems)
          } else {
            setFavoritesPage([])
          }
        })
      if (isSaveProductToList) {
        dispatch(getMyAccountListsWithLineItems())
          .unwrap()
          .then(res => {
            if (Object.keys(res[1]).length) {
              setFavoritesPage(Object.keys(res[1]))
            } else {
              setFavoritesPage([])
            }
          })
      }
    }
  }, [isAuth, isSaveProductToList])

  useEffect(() => {
    if (favorites?.lineItems && favorites?.lineItems.length > 0) {
      setFavoritesPage(favorites?.lineItems)
    } else {
      setFavoritesPage([])
    }
  }, [favorites])

  useEffect(() => {
    if (Object.keys(saveToListLineItems).length && isAuth) {
      setFavoritesPage(Object.keys(saveToListLineItems))
    } else {
      setFavoritesPage([])
    }
  }, [Object.keys(saveToListLineItems).length])

  const onClickSignOut = () => {
    dispatch(logout())
    dataLayerForSignOut()
  }
  const setPromoModal = data => {
    dispatch(showPromoModal(data))
  }
  useEffect(() => {
    if (loginFavouriteCallback && isAuth) {
      window.loginFavouriteCallback = null
      setLoginFavouriteCallback(null)
      window.location.href = myListsPagePath
    }
  }, [loginFavouriteCallback, isAuth])
  const getNavMobileData = async () => {
    try {
      const fetchGlobalConfig = async () => {
        try {
          const res = await aemAxiosInstance({
            url: GLOBAL_CONFIGURATION_ENDPOINT,
            method: "GET",
          })
          return res?.data ?? null
        } catch (e) {
          console.warn("fetchGlobalConfig failed (aemAxiosInstance)", e)
          return null
        }
      }
      // Resolve fragment paths from local props / globalConfig map / proxy
      let signInPath = signInFragment
      let signUpPath = signUpFragment
      if (!signInPath || !signUpPath) {
        const curMap = globalConfig?.contentFragmentListConfig?.map
        if (curMap?.mobileNavigation) {
          signInPath = signInPath || curMap.mobileNavigation.signInFragment
          signUpPath = signUpPath || curMap.mobileNavigation.signUpFragment
        }
      }
      if (!signInPath || !signUpPath) {
        const fetched = await fetchGlobalConfig()
        if (fetched) {
          signInPath = signInPath || fetched?.general?.signInFragment
          signUpPath = signUpPath || fetched?.general?.signUpFragment
          const fetchedMap = fetched?.contentFragmentListConfig?.map
          if (fetchedMap?.mobileNavigation) {
            signInPath =
              signInPath || fetchedMap.mobileNavigation.signInFragment
            signUpPath =
              signUpPath || fetchedMap.mobileNavigation.signUpFragment
          }
        }
      }
      if (!signInPath && !signUpPath) {
        console.warn(
          "getNavMobileData: no signIn/signUp fragment values available after fallback attempts"
        )
        return
      }
      const fetchFragment = async path => {
        if (!path) return null
        try {
          const res = await aemAxiosInstance({
            url: `${GLOBAL_CONFIGURATION_ENDPOINT}?path=${encodeURIComponent(
              path
            )}`,
            method: "GET",
          })
          return res?.data ?? null
        } catch (e) {
          console.warn("fetchFragment failed (aemAxiosInstance)", path, e)
          return null
        }
      }
      const [signInRes, signUpRes] = await Promise.all([
        fetchFragment(signInPath),
        fetchFragment(signUpPath),
      ])

      const logIndataResp = signInRes?.commonTopics || []
      const loggedOutDataResp = signUpRes?.commonTopics || []
      setLogIndata(logIndataResp)
      setLogOutdata(loggedOutDataResp)
    } catch (err) {
      console.error("getNavMobileData: error fetching fragments", err)
    }
  }

  const favClickHandler = (e, path = "") => {
    dataLayerForUtilityClicks("favorites", false, favoritesPagePath)
    if (!isAuth) {
      window.loginFavouriteCallback = () => {
        setLoginFavouriteCallback(e)
      }
      if (path) setMyListsPagePath(path)
      onclicksignIN(false)
      e.stopPropagation()
      e.preventDefault()
    } else if (path && isAuth) {
      router.push(path)
    }
  }
  const { contentFragmentListConfig: { map: fragmentList = {} } = {} } =
    globalConfig

  useEffect(() => {
    if (Object.keys(fragmentList).length) getNavMobileData()
  }, [fragmentList])

  const [width] = useWindowResize()
  const navigationProps = mapMainMenuProps(
    header,
    i18n,
    lineItems,
    firstName,
    isAuth,
    logIndata,
    logOutdata,
    onclicksignIN,
    onClickCreateAccount,
    onClickSignOut,
    favClickHandler,
    cartCount,
    themeType?.includes("light") ? "light" : "dark",
    handleSearchClick,
    !themeType?.includes("transparent"),
    favoritesPage,
    favoritesPagePath,
    cartLandingPagePath,
    router.asPath,
    setPromoModal,
    canadaCheck,
    navigationHoverTiming,
    staticTexts.searchHeader,
    language,
    isSaveProductToList,
    width
  )

  const getStoreAnalytics = action => {
    const href =
      utilityStoreDetails && utilityStoreDetails[utilityData?.BPnumber]
        ? utilityStoreDetails[utilityData?.BPnumber]
        : "/"
    const internalLinkName =
      action === "unset as my store"
        ? "unset as preferred store"
        : action === "set as my store"
        ? "set as preferred store"
        : "store details"
    return JSON.stringify({
      eventAction: "find a store:utility nav:" + action,
      eventName: "find a store:utility nav:" + action,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName,
      internalLinkPosition: "find a store",
      internalLinkType:
        "find a store:" +
        (
          utilityData?.LocationName +
          ", " +
          utilityData?.AddressLine +
          (!_isEmpty(utilityData?.AddressLine2)
            ? ", " + utilityData?.AddressLine2
            : "") +
          ", " +
          formatPhoneNumber(utilityData?.Phone)
        )?.toLowerCase(),
      internalLinkZoneName: "find a store:utility nav",
      internalLinkURL:
        typeof window !== "undefined"
          ? action === "view store details"
            ? href.indexOf("http") === -1
              ? window.location.origin + href
              : href
            : "n/a"
          : "n/a",
      clickInternalLinks: "true",
    })
  }

  const viewStoreAnalytics = getStoreAnalytics("view store details")
  const unsetMyStoreAnalytics = getStoreAnalytics(
    myStoreId === utilityData?.EntityID
      ? "set as my store"
      : "unset as my store"
  )

  const storeMenu = {
    mod: "charcoal",
    eyebrow: {
      text: (
        <div>
          {" "}
          {!_isEmpty(utilityData && utilityData?.EntityID)
            ? myStoreId !== 0
              ? staticTexts?.myStore
              : staticTexts?.closestStore
            : ""}{" "}
        </div>
      ),
    },
    heading: {
      text: (
        <div>
          {" "}
          {!_isEmpty(utilityData && utilityData?.EntityID)
            ? utilityData?.LocationName
            : staticTexts?.locationDescription}{" "}
        </div>
      ),
    },
    subheading: {
      text: (
        <div>
          {" "}
          {!_isEmpty(utilityData && utilityData?.EntityID)
            ? ""
            : staticTexts?.zipCodeContent}{" "}
        </div>
      ),
    },
    storeInfo: !_isEmpty(utilityData && utilityData?.EntityID) ? (
      <div>
        <p>{utilityData?.OpenUntil}</p>
        <p>
          <span>{utilityData?.AddressLine}</span>
          {!_isEmpty(utilityData?.AddressLine2) ? (
            <span>{utilityData?.AddressLine2}</span>
          ) : (
            ""
          )}
          <br />
          <span>
            {utilityData?.Locality +
              ", " +
              utilityData?.AdminDistrict +
              " " +
              utilityData?.PostalCode}
          </span>
        </p>
        <p>{formatPhoneNumber(utilityData?.Phone)}</p>
        {myStoreUrl && (
          <a
            className="store-a"
            href={myStoreUrl}
            data-datalayer-id="kds-element-navigation"
            data-datalayer-data={viewStoreAnalytics}
          >
            {staticTexts?.storeDetail}
          </a>
        )}
      </div>
    ) : undefined,
    setStoreCTA: {
      label: (
        <div>
          {" "}
          {!_isEmpty(utilityData && utilityData?.EntityID)
            ? myStoreId === utilityData?.EntityID
              ? staticTexts?.myStore
              : staticTexts?.setAsMyStore
            : ""}{" "}
        </div>
      ),
      onChange: e => (
        <div>
          {" "}
          {!_isEmpty(utilityData && utilityData?.EntityID)
            ? handleUtilityStoreCheck(
                e.target.checked ? utilityData?.EntityID : 0
              )
            : ""}{" "}
        </div>
      ),
      checked: myStoreId === utilityData?.EntityID,
      "data-datalayer-id": "kds-element-navigation",
      "data-datalayer-data": unsetMyStoreAnalytics,
    },
    zipCodeInput: {
      eyebrow: {
        text: staticTexts?.NotYourStore + "?",
      },
      optionList: optionList,
      label: staticTexts?.enterCityStateZip,
      inputValue: zipCodeValue,
      onInputChange: e => {
        handleZipCodeUpdate(e.target.value)
      },
      handleSubmit: zipCode => {
        redirect(zipCode)
      },
      CTA: {
        text: staticTexts?.submit,
        trackingAttributes: {
          "data-datalayer-id": "kds-element-navigation",
          "data-datalayer-data": JSON.stringify({
            eventAction: "find a store:utility nav:submit",
            eventName: "find a store:utility nav:submit",
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "success",
            internalLinkName: "submit",
            internalLinkPosition: "find a store",
            internalLinkType: `find a store:${zipCodeValue ?? ""}`,
            internalLinkZoneName: "find a store:utility nav",
            internalLinkURL: "n/a",
            clickInternalLinks: "true",
          }),
        },
      },
    },
    CTAs: [
      {
        text: staticTexts?.userMyLocation,
        onClick: () => {
          getGeoLocation()
        },
        component: "button",
      },
      {
        text: staticTexts?.viewAllStore,
        href: browseAllStoreUrl,
        trackingAttributes: {
          "data-datalayer-id": "kds-element-navigation",
          "data-datalayer-data": JSON.stringify({
            eventAction: "find a store:utility nav:view all stores",
            eventName: "find a store:utility nav:view all stores",
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "view all stores",
            internalLinkPosition: "global header:find a store",
            internalLinkType: "find a store:navigation",
            internalLinkZoneName: "find a store:utility nav",
            internalLinkURL:
              typeof window !== "undefined"
                ? `${window.location.origin}${browseAllStoreUrl}`
                : "n/a",

            clickInternalLinks: "true",
          }),
        },
        component: "a",
      },
    ],
  }

  useEffect(() => {
    if (typeof window !== "undefined") {
      const isFirstTimeValue =
        localStorage.getItem("usingVSforFirstTime") === "true"
      setIsFirstTime(isFirstTimeValue)
    }
  }, [])

  useEffect(() => {
    const handleStorageChange = event => {
      if (event.key === "usingVSforFirstTime") {
        setIsFirstTime(event.newValue === "true")
      }
    }

    window.addEventListener("storage", handleStorageChange)

    return () => {
      window.removeEventListener("storage", handleStorageChange)
    }
  }, [])

  useEffect(() => {
    const updateSearchIcon = () => {
      const searchButtons = Array.from(
        document.querySelectorAll(
          '.kohler-main-navigation-bar-root button[aria-label="Search"]'
        )
      )

      document
        .querySelectorAll(
          ".kohler-main-menu-root, .kohler-date-picker-root, .kohler-main-navigation-bar-root"
        )
        .forEach(root => {
          root.querySelectorAll("button").forEach(btn => {
            btn.classList.add("af-icon-button")
          })
        })

      if (searchButtons.length === 0) return

      const targetButton = searchButtons[searchButtons.length - 1]
      targetButton.style.marginRight = "0px"

      targetButton.classList.add("globalvs-feat-toggle")

      const computedStyle = window.getComputedStyle(targetButton)
      const isHidden = computedStyle.display === "none"

      if (isHidden) {
        targetButton.classList.remove("globalvs-feat-toggle")
        setSearchIconContainer(null)
        return
      }

      const svg = targetButton.querySelector("svg")
      const hasSiblingSpan = svg?.parentElement?.querySelector("span")

      if (
        svg &&
        !hasSiblingSpan &&
        !svg.classList.contains("nav-search-icon")
      ) {
        svg.remove()
      }

      setSearchIconContainer(targetButton)
    }

    updateSearchIcon()

    const observer = new MutationObserver(() => updateSearchIcon())
    observer.observe(document.body, { childList: true, subtree: true })

    window.addEventListener("scroll", updateSearchIcon)
    window.addEventListener("resize", updateSearchIcon)
    return () => {
      observer.disconnect()
      window.removeEventListener("scroll", updateSearchIcon)
      window.removeEventListener("resize", updateSearchIcon)
    }
  }, [isFirstTime, isLargeScreen, isExtraLargeScreen])

  useEffect(() => {
    const mainMenu = document?.querySelector(".kohler-main-navigation-bar-root")
    if (!mainMenu) return
    const mainNavContainer = mainMenu?.querySelector(
      ".kohler-grid-root > div > .kohler-flex-root"
    )
    if (!mainNavContainer) return

    const vsSearchPlaceholder = document.createElement("div")

    const navContainers = mainNavContainer.querySelectorAll(
      ":scope > .kohler-flex-root"
    )

    if (navContainers?.length > 0) {
      const addVsSearchAtLast = navContainers[navContainers?.length - 1]
      addVsSearchAtLast.insertAdjacentElement("afterend", vsSearchPlaceholder)
    } else {
      mainNavContainer.appendChild(vsSearchPlaceholder)
    }
    Array.from(mainNavContainer.children).forEach((child, index) => {
      child.style.order = `${index + 1}`
    })
    setTarget(vsSearchPlaceholder)
  }, [])

  useEffect(() => {
    const observer = new MutationObserver(() => {
      document.querySelectorAll(".kohler-overlay-menu-root").forEach(root => {
        root.querySelectorAll("button").forEach(btn => {
          btn.classList.add("af-icon-button")
        })
      })
    })
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })
    return () => observer.disconnect()
  }, [])

  return (
    <>
      <Head>
        {title ? (
          <>
            <title>{title}</title>
            <meta property="og:title" content={title} />
          </>
        ) : null}
        {description ? (
          <>
            <meta name="description" content={description} />
            <meta property="og:description" content={description} />
          </>
        ) : null}
        <meta property="og:type" content={isPdp ? "product" : "website"} />
        {siteName ? <meta property="og:site_name" content={siteName} /> : null}
        {pageUrl ? <meta property="og:url" content={pageUrl} /> : null}
        {imageUrl ? <meta property="og:image" content={imageUrl} /> : null}
        {email ? <meta property="og:email" content={email} /> : null}
        {phone ? <meta property="og:phone_number" content={phone} /> : null}

        {metas.map((meta, i) => {
          if (meta.name && meta.content)
            return (
              <meta key={`meta-${i}`} name={meta.name} content={meta.content} />
            )
        })}
        {styles.map((style, i) => {
          if (typeof style === "string")
            return (
              <React.Fragment key={`pagestyle-${i}-${getRandom()}`}>
                <style jsx global>
                  {style}
                </style>
              </React.Fragment>
            )
        })}
        {links.map((link, i) => {
          if (typeof link !== "string")
            return (
              <link key={`pageLinks-${i}`} rel={link.rel} href={link.href} />
            )
        })}
      </Head>
      {pageIsInteractive &&
        scripts.map((script, i) => {
          if (script.src)
            return (
              <Script
                key={`headscript-${i}`}
                src={script.src}
                type={script.type}
                integrity={script.integrity}
                id={`headscript-${i}`}
              />
            )
          if (!script.src && script.innerHTML)
            return (
              <Script key={`headscriptHtml-${i}`} id={`headscriptHtml-${i}`}>
                {`${script.innerHTML}`}
              </Script>
            )
        })}
      <button
        type="button"
        className="skip-to-main"
        onClick={handleSkipToMain}
        aria-label={staticTexts?.skipToMainContent}
        role="link"
      >
        {staticTexts?.skipToMainContent}
      </button>
      {headerItemsPresent ? (
        <MainMenu {...navigationProps} storeMenu={storeMenu} />
      ) : null}
      {infoModal && (
        <ZipCodeInfoModal
          handleModalClose={() => setInfoModal(false)}
          show={infoModal}
          data={infoModalErrror}
          labelledBy="Geo-Location-error-message"
          className="message-modal"
          staticTexts={staticTexts}
          dataLayerPosition="global header"
          label={staticText.continue}
        />
      )}
      {showSearchBar && (
        <UtilityWidgets
          showSearchBar={showSearchBar}
          handleSearchClick={handleSearchClick}
          setOpenVisualSearch={setOpenVisualSearch}
          data={findItemByName(header, "utilitywidgets")}
          isFirstTime={isFirstTime}
          setIsFirstTime={setIsFirstTime}
          setShowSearchBar={setShowSearchBar}
        />
      )}
      <>
        {target &&
          isGlobalVisualSearchEnabled &&
          (isLargeScreen || isExtraLargeScreen) &&
          ReactDOM.createPortal(
            <GlobalVSContent
              className={"ml-15 pb-2 globalvs-feat-toggle"}
              openVisualSearch={openVisualSearch}
              setOpenVisualSearch={setOpenVisualSearch}
              setShowSearchBar={setShowSearchBar}
              isFirstTime={isFirstTime}
              setIsFirstTime={setIsFirstTime}
            />,
            target
          )}
        {searchIconContainer &&
          ReactDOM.createPortal(
            <SearchNotification
              isFirstTime={isFirstTime}
              onClickHandler={() => setShowSearchBar(true)}
            />,
            searchIconContainer
          )}
        {!(isLargeScreen || isExtraLargeScreen) && (
          <GlobalVisualSearch
            openVisualSearch={openVisualSearch}
            setOpenVisualSearch={setOpenVisualSearch}
            setShowSearchBar={setShowSearchBar}
          />
        )}
      </>
    </>
  )
}
export default GlobalPageHeader
